import api from './api';

const helpSupportService = {
  getAllTickets: (params) => api.get('/help-support/admin/all', { params }),
  getTicketById: (id) => api.get(`/help-support/admin/${id}`),
  addResponse: (ticketId, data) => api.post(`/help-support/admin/${ticketId}/respond`, data),
  updateStatus: (ticketId, data) => api.patch(`/help-support/admin/${ticketId}/status`, data),
  getStats: () => api.get('/help-support/admin/stats'),
};

export default helpSupportService;
